export default "__VITE_ASSET__PZRux2ve__"